/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import GrayPlus from '../Buttons/grayPlus';
import OwnerDropdown from './ownerDropdown';

const MAX_OWNERS = 3;
class Owners extends React.Component {
  constructor() {
    super();
    this.state = {
      addCoOwner: null
    };
    this.selectOwner = this.selectOwner.bind(this);
    this.addCoOwner = this.addCoOwner.bind(this);
  }

  selectOwner(value) {
    const { allowEdit } = this.props;
    const ownerIds = Array.from(
      this.props.owners.filter(owner => owner.id !== value),
      owner => owner.id
    );
    const options = Array.from(
      this.props.users.filter(user => !ownerIds.includes(user.id)),
      user => ({ label: user.nickname || user.name, value: user.id })
    );
    options.unshift({ label: '', value: null });

    return (
      <div key={`TOSelect${value}`}>
        <OwnerDropdown
          ownerId={value}
          ownerOptions={options}
          handleOwnerAddition={this.props.handleOwnerAddition}
          handleOwnerRemoval={this.props.handleOwnerRemoval}
          handleOwnerEdit={this.props.handleOwnerEdit}
          taskId={this.props.taskId}
          disabled={!allowEdit}
        />
      </div>
    );
  }

  addCoOwner(event) {
    event.preventDefault();
    const newCoOwner = (
      <div className="col-sm-8 new-co-owner">{this.selectOwner(null)}</div>
    );
    if (this.props.owners.length < MAX_OWNERS)
      this.setState({ addCoOwner: newCoOwner });
  }

  render() {
    const { owners } = this.props;
    const maxOwnersReached = owners.length === MAX_OWNERS;
    return (
      <div className="owner-section">
        <label>Assign Owner</label>
        <div>
          <div className="col-sm-8">
            {owners.length > 0
              ? owners.reverse().map(owner => this.selectOwner(owner.id))
              : this.selectOwner(null)}
          </div>
          {this.props.allowEdit && (
            <div
              className={`col-sm-4 text-center ${
                maxOwnersReached ? 'disabled' : ''
              }`}
            >
              <span className="co-owner"> Add Co-Owner </span>
              <GrayPlus handleClick={this.addCoOwner} />
            </div>
          )}
          {maxOwnersReached ? null : this.state.addCoOwner}
        </div>
      </div>
    );
  }
}

Owners.propTypes = {
  taskId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  users: PropTypes.array,
  owners: PropTypes.array,
  allowEdit: PropTypes.bool,
  handleOwnerAddition: PropTypes.func,
  handleOwnerEdit: PropTypes.func,
  handleOwnerRemoval: PropTypes.func
};

export default Owners;
